import React, { Component } from "react";

import { isMobile } from "react-device-detect";
import { compose } from "recompose";
import { withFirebase } from "../../../Firebase";
import { connect } from "react-redux";
import "./sigpad.css";

import SignatureCanvas from "react-signature-canvas";

class PhotoUploadPass extends Component {
  state = {
    uploading: false,
    progress: "0"
  };

  componentDidMount() {
    this.sigCanvas.fromDataURL(this.props.sigB64);
  }

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px",
          borderBottom: "0px",
          borderBottomColor: "#cccccc",
          borderStyle: "solid",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-8"
          style={{
            padding: "1px",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            minHeight: "100px",
            textAlign: "center"
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              style={{
                padding: "1px",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor: "rgb(30, 101, 144)",
                margin: "5px",
                padding: "6px",
                fontWeight: "bold",
                color: "white",
                width: "100px",
                fontSize: "12px"
              }}
              onClick={() => {
                this.sigCanvas.clear();
                this.props.stateChangeHandler("", this.props.fieldName, false);
              }}
            >
              <div>
                <i className="fa fa-trash"></i> {"CLEAR"}
              </div>
              <div>{"মুছে ফেলুন"}</div>
            </div>
            <div style={{ margin: "auto", fontSize: "12px" }}>
              <div>{"SIGNATURE BELOW"}</div>
              <div>{"এইখানে সাইন করুন"}</div>
            </div>
          </div>

          <SignatureCanvas
            penColor="blue"
            canvasProps={{
              className: "sigPad"
            }}
            ref={ref => {
              this.sigCanvas = ref;
            }}
            onEnd={() => {
              //console.log(this.sigCanvas.toDataURL());
              this.props.stateChangeHandler(
                this.sigCanvas.toDataURL(),
                this.props.fieldName,
                false
              );
            }}
          />
        </div>

        <input
          type="file"
          accept="image/*"
          id={"uploader" + this.props.fieldName}
          onChange={evt => {
            console.log("clicked");
            //console.log("triggering main function");
            event.preventDefault();

            if (evt.target.files[0]) {
              this.uploadImage(evt.target.files);
            } else {
              console.log("gotcha");
            }
          }}
          style={{
            visibility: "hidden"
          }}
        />
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    null
  ),
  withFirebase
)(PhotoUploadPass);



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/SignPad/SignPad.jsx